var _rect, _rect2, _rect3, _rect4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcoOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 40,
    viewBox: "0 0 60 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 39,
    rx: 2,
    stroke: "#DBE0E6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 6.80933,
    width: 59.2105,
    height: 7.56579,
    fill: "#DBE0E6"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.6842,
    y: 19.6711,
    width: 15,
    height: 14.375,
    rx: 3,
    fill: "#DBE0E6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9.47363,
    y: 28.75,
    width: 15.6522,
    height: 5,
    rx: 2,
    fill: "#DBE0E6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoOther);
export default __webpack_public_path__ + "static/media/ico_other.236a09ae8de787308507845dd7a94270.svg";
export { ForwardRef as ReactComponent };